@use '@lib/assets/styles/main.scss' as *;

.body {
  margin: -8px -16px;
}
